/**
 * 解析路由所需的逻辑权限
 * - meta.permission === false：无需权限（如首页、待办）
 * - meta.permission 为字符串或数组：显式指定
 * - 未指定：从叶子到根查找继承，最终默认使用页面 path（去掉前导 /）
 */
export function resolveRoutePermission(to) {
  for (let i = to.matched.length - 1; i >= 0; i--) {
    const { permission } = to.matched[i].meta
    if (permission === false) return false
    if (permission != null && permission !== '') return permission
  }
  return to.path.replace(/^\//, '')
}
